import awardsData from '../data/awards.json';
import { Award } from '../models/award.interface';

export class AwardsService {
    private awards: Award[] = [];

    constructor() {
        this.awards = awardsData.awards as Award[];
    }

    getAwards(): Award[] {
        return this.awards;
    }
}

export const awardsService = new AwardsService();
